module.exports = __webpack_public_path__ + "static/img/liveacc.c27b9ed.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/registerflow-new/liveacc.svg
// module id = gJgY
// module chunks = 4